module.exports = __webpack_public_path__ + "media/icons/opony-felgi-baner-ce362b5e.png";